import { MANIFESTO } from "@/constants/site";
import { Reveal } from "@/lib/motion";

export const About = ({ content = {} }) => (
  <section id="hakkimizda" data-testid="about-section" className="bg-surface py-24 lg:py-32">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <div className="grid lg:grid-cols-12 gap-10 lg:gap-16">
        <div className="lg:col-span-5">
          <Reveal>
            <span className="text-xs font-semibold uppercase tracking-[0.2em] text-brand">
              {content.about_eyebrow || "Hakkımızda"}
            </span>
            <h2 className="mt-4 font-heading font-bold text-ink text-3xl sm:text-4xl lg:text-5xl leading-tight tracking-tight">
              {content.about_title || "Sevgiyle üretmek, güvenle büyümek."}
            </h2>
            <p className="mt-6 text-base sm:text-lg text-ink/70 leading-relaxed">
              {content.about_description || "Nolena Global, pet ürünleri üretiminde kaliteyi, güveni ve güçlü iş ortaklığını merkeze alan bir markadır. Evcil dostlarımızın sağlığı ve mutluluğu için doğal, güvenilir ve yenilikçi ürünler geliştiriyor; bayilerimizle birlikte sürdürülebilir bir büyüme kurguluyoruz."}
            </p>
          </Reveal>
        </div>

        <div className="lg:col-span-7">
          <div className="space-y-5">
            {(content.story_chapters?.length ? content.story_chapters.map((chapter, index) => ({ ...chapter, no: String(index + 1).padStart(2, "0") })) : MANIFESTO).map((ch, i) => (
              <Reveal key={ch.no} delay={i * 0.12}>
                <div
                  data-testid={`manifesto-chapter-${ch.no}`}
                  className="group flex gap-6 rounded-3xl border border-detail bg-cream p-6 sm:p-8 transition-colors duration-300 hover:border-brand/40"
                >
                  <span className="font-heading font-bold text-4xl sm:text-5xl text-brand/25 leading-none tabular-nums transition-colors duration-300 group-hover:text-brand/60">
                    {ch.no}
                  </span>
                  <div>
                    <h3 className="font-heading font-semibold text-xl sm:text-2xl text-ink">
                      {ch.title}
                    </h3>
                    <p className="mt-2 text-base text-ink/70 leading-relaxed">
                      {ch.text}
                    </p>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </div>
  </section>
);
